import get from 'lodash/get'
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { siteMetadata } from '../../gatsby-config'
import { Row, Col, Container, Button } from 'reactstrap'
import { navigate } from 'gatsby-link'
// import VideoSavasa from '../components/VideoSavasa'
import bgHomeImg from '../images/bg-home.901ba482.jpg'
import HomeImg from '../images/crop1.jpeg'

import IconCerveja from '../images/Home/Icones/01-Cervejas-.jpg'
import ImgAgua from '../images/Home/Agua.jpg'
import IconBebidasRefrescante from '../images/Home/Icones/03-BEBIDAS_REFRESCANTES-.jpg'
import IconProdutoLimpeza from '../images/Home/Icones/04-Produtos_de_Limpeza-.jpg'

import 'react-alice-carousel/lib/alice-carousel.css'
import '../styles/home.scss'

export default class Index extends Component {
  constructor () {
    super()
    // const isBrowser = typeof window !== 'undefined'
    // let valido = ''
    // if (isBrowser) {
    //   valido = JSON.parse(window.localStorage.getItem('visto'))
    // }
    this.state = { width: -1 }
    // console.log('visto: ', this.state.visto)
  }

  onSlideChange (e) {
    // console.log('Item`s position during a change: ', e.item)
    // console.log('Slide`s position during a change: ', e.slide)
  }

  onSlideChanged (e) {
    // console.log('Item`s position after changes: ', e.item)
    // console.log('Slide`s position after changes: ', e.slide)
  }

  onClickPhoto (event, obj) {
    // console.log(event, obj)
    navigate('/portfolio')
  }

  render () {
    // const width = this.state.width
    // const pathPrefix =
    //   process.env.NODE_ENV === 'development' ? '' : __PATH_PREFIX__
    return (
      <div>
        <Helmet
          title={`${get(siteMetadata, 'title')}`}
          meta={[
            { name: 'author', content: get(siteMetadata, 'author') },
            { name: 'description', content: get(siteMetadata, 'description') },
            {
              name: 'keywords',
              content: get(siteMetadata, 'keywords')
            },
            { property: 'og:title', content: get(siteMetadata, 'title') },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: get(siteMetadata, 'description')
            },
            {
              property: 'og:url',
              content: `${get(siteMetadata, 'siteUrl')}`
            },
            {
              property: 'og:image',
              content: `${get(
                siteMetadata,
                'siteUrl'
              )}/favicon/android-icon-512x512.png`
            }
          ]}
        />
        <img src={HomeImg} style={{ width: '100%' }} alt='imagem savasa'/>
        {/* <VideoSavasa /> */}
        <Container fluid>
          <Row
            style={{
              backgroundImage: 'url(' + bgHomeImg + ')',
              minWidth: '100%',
              minHeight: '100%'
            }}
            className="py-5"
          >
            <Col xs="12">
              <div className="text-white">
                <h1
                  className="mt-3 text-center font-weight-bold"
                  style={{ fontFamily: 'LaBelleAurore' }}
                >
                  Mais que um rótulo, sua marca.
                </h1>
                <h2
                  className="mt-4 text-center"
                  style={{ letterSpacing: '10px' }}
                >
                  SAVASA IMPRESSORES
                </h2>
                <h2
                  className="mt-3 text-center font-weight-bold"
                  style={{ letterSpacing: '10px' }}
                >
                  25 ANOS INOVANDO
                </h2>
                <p className="m-5 text-center">
                  Desde sua fundação em 1997, os profissionais da Savasa
                  Impressores Ltda. tem dedicado <br /> todos seus esforços para
                  uma única atividade: criar rótulos de valor agregado,
                  oferecendo <br /> soluções inovadoras aos clientes.
                </p>
                <div className="text-center">
                  <Button
                    href="/sobre"
                    outline
                    color="secondary"
                    className="mx-auto py-2 px-4"
                  >
                    SAIBA MAIS
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Container style={{ marginBottom: '5rem' }}>
          <Row>
            <Col xs="12">
              <h2
                className="my-5 text-center fc-E66827"
                style={{ letterSpacing: '10px' }}
              >
                CONHEÇA NOSSO PORTFOLIO
              </h2>
            </Col>
          </Row>
          <Row style={{ maxWidth: '700px' }} className="text-center m-auto">
            <Col xs="6" md="3">
              <a href="/portfolio#Cervejas">
                <img
                  src={IconCerveja}
                  className="img-fluid mt-2"
                />
              </a>
            </Col>
            <Col xs="6" md="3">
              <a href="/portfolio#Aguas">
                <img
                  src={ImgAgua}
                  className="img-fluid mt-2"
                />
              </a>
            </Col>
            <Col xs="6" md="3">
              <a href="/portfolio#Refrescos">
                <img
                  src={IconBebidasRefrescante}
                  className="img-fluid mt-2"
                />
              </a>
            </Col>
            <Col xs="6" md="3">
              <a href="/portfolio#Higiene">
                <img
                  src={IconProdutoLimpeza}
                  className="img-fluid mt-2"
                />
              </a>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}
